// otras utilidades para el sistema

window.precioConIva=function(entrada){
    console.log(entrada);
    if(entrada!=undefined){
        var tarifa = $(entrada).val().replace(/_.{1,}|\,{1,}/, "");
        $(entrada).parent().find(".precioConIva").html("$"+( tarifa * ($("#impuesto").val()/100 + 1)).toFixed(2) );
    }else{
        var tarifa = $("#tarifa").val().replace(/_.{1,}|\,{1,}/, "");
        $("#tarifa").parent().find(".precioConIva").html("$"+( tarifa * ($("#impuesto").val()/100 + 1)).toFixed(2) );
        
        var tarifa = $("#tarifaSencillo").val().replace(/_.{1,}|\,{1,}/, "");
        $("#tarifaSencillo").parent().find(".precioConIva").html("$"+( tarifa * ($("#impuesto").val()/100 + 1)).toFixed(2) );
    }
}

window.compraDeshabilitada=function (chk){
    if(chk.checked){
        $(".compraDeshabilitada .clipCheckoutButton")
            .css("pointer-events", "all")
            .css("filter", "none");
    }else{
        $(".compraDeshabilitada .clipCheckoutButton")
            .css("pointer-events", "none")
            .css("filter", "grayscale(1)");
    }
}

window.validateUpdateUser=function(){
    let form=$("#editUser");
    let valid=true;
    let nombre=$(form).find("#nombre");
    let telefono=$(form).find("#telefono");
    let contrasena=$(form).find("#contrasena");
    let contrasenaConf=$(form).find("#contrasenaConf");

    nombre.removeClass("is-invalid");
    telefono.removeClass("is-invalid");
    contrasena.removeClass("is-invalid");
    contrasenaConf.removeClass("is-invalid");

    if (!nombre.val().match(/([a-zA-ZàèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ]{3,})+((\x20)+([a-zA-ZàèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ]{2,})){1,}/)) { //Con expresión regular
        console.log('Escriba al menos un nombre y apellido');
        nombre.addClass("is-invalid");
        valid = false;
    }else{
        nombre.removeClass("is-invalid");
    }
    if (!(/^(\+[0-9]{2}\x20)?\([0-9]{3}\)+\x20([0-9]{3})+\x20[0-9]{4}/.test(telefono.val()))) { //Con expresión regular
        telefono.addClass("is-invalid");
        valid = false;
    }else{
        telefono.removeClass("is-invalid");
    }

    if (contrasena.val() != "") { //Con expresión regular
        if(contrasena.val().length<8){
            contrasena.addClass("is-invalid");
            valid = false;
        }
        if (contrasena.val() != contrasenaConf.val()){
            contrasenaConf.addClass("is-invalid");
            valid = false;
        }
    }else{
        contrasena.removeClass("is-invalid");
    }
    return valid;
}

// GLOBALES

window.mayusculas = function (event) {
    var key = event.keyCode;
    if (event.keyCode >= 65 && event.keyCode <= 90 || event.keyCode == 32
        || event.keyCode == 37
        || event.keyCode == 38
        || event.keyCode == 39
        || event.keyCode == 40
        || event.keyCode == 8
        || event.keyCode == 9
    ) {
        return true;
    } else {
        console.log(event.keyCode);
        return false;
    }
}

window.lettersOnly = function (evt) {
    evt = (evt) ? evt : event;
    var charCode = (evt.charCode) ? evt.charCode : ((evt.keyCode) ? evt.keyCode :
        ((evt.which) ? evt.which : 0));
    if (charCode > 31 && (charCode < 65 || charCode > 90) &&
        (charCode < 97 || charCode > 122)) {
        // alert("Enter letters only.");
        return false;
    }
    return true;
}

